import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges
} from '@angular/core';
import { BaseModalComponent } from '../../../../models/base/base-modal.component';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BehaviorSubject, Observable } from 'rxjs';
import { BaseButtonSizeEnum } from '../../components/base-button/base-button-size.enum';
import { BaseButtonColourEnum } from '../../components/base-button/base-button-colour.enum';
import { SecondaryButtonStyleEnum } from '../base-action-modal/base-action-modal.component';
import { CloseButtonComponent } from '../../components/close-button/close-button.component';
import { SecondaryButtonComponent } from '../../components/secondary-button/secondary-button.component';
import { TertiaryButtonComponent } from '../../components/tertiary-button/tertiary-button.component';
import { PrimaryButtonComponent } from '../../components/primary-button/primary-button.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-base-loading-button-modal',
  templateUrl: './base-loading-button-modal.component.html',
  standalone: true,
  styleUrls: ['../base-action-modal/base-action-modal.component.scss'],
  imports: [
    CommonModule,
    CloseButtonComponent,
    SecondaryButtonComponent,
    TertiaryButtonComponent,
    PrimaryButtonComponent
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BaseLoadingButtonModalComponent extends BaseModalComponent implements OnChanges {
  // Ensure modalTitle is localized before being passed in
  @Input() modalTitle: string = '';
  // Ensure primaryLabel is localized before being passed in
  @Input() primaryLabel: string = '';
  // Ensure secondaryLabel is localized before being passed in
  @Input() secondaryLabel: string = '';
  @Input() secondaryButtonStyle: SecondaryButtonStyleEnum = SecondaryButtonStyleEnum.Tertiary;

  @Input() isLoading: boolean = false;
  @Input() hidePrimary: boolean = false;
  @Input() hideSecondary: boolean = false;
  @Input() hideClose: boolean = false;
  // Use in conjunction with ignoreEscapeModalOptions to ensure the modal
  // cannot be closed on escape
  @Input() ignoreEscape: boolean = false;

  @Output() closeClicked: EventEmitter<any> = new EventEmitter<any>();
  @Output() primaryClicked: EventEmitter<any> = new EventEmitter<any>();
  @Output() secondaryClicked: EventEmitter<any> = new EventEmitter<any>();

  constructor(private activeModal: NgbActiveModal) {
    super(activeModal);
  }

  private _isLoading = new BehaviorSubject(false);
  public isLoading$ = this._isLoading as Observable<boolean>;

  setupBindings(): void {}

  setupViews(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.isLoading) {
      this._isLoading.next(this.isLoading);
    }
  }

  protected readonly BaseButtonSizeEnum = BaseButtonSizeEnum;
  protected readonly BaseButtonColourEnum = BaseButtonColourEnum;
  protected readonly SecondaryButtonStyleEnum = SecondaryButtonStyleEnum;
}
